import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/default.jpg'


const _hoisted_1 = { class: "hidden md:block md:ml-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Add Allergy")
const _hoisted_3 = { class: "flex flex-col mb-3 justify-center items-center w-screen space-y-3 overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "py-4 font-bold"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Welcome, ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "w-1/2 md:w-1/4" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-center flex-wrap items-center gap-7 md:gap-3"
}
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { id: "components-a-tooltip-demo-color" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-center my-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_RiseOutlined = _resolveComponent("RiseOutlined")!
  const _component_FallOutlined = _resolveComponent("FallOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_button, {
        type: "primary",
        size: _ctx.size
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/add-allergy" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["size"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.currentUser)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
            _hoisted_5,
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "admin ;)"))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.currentUser), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_form_item, { name: "searchTerm" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.searchTerm,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              placeholder: "Search...",
              size: _ctx.size
            }, null, 8, ["value", "size"])
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.allergies.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allergies, (allergy) => {
            return (_openBlock(), _createBlock(_component_a_card, {
              hoverable: "",
              class: "w-11/12 md:w-80",
              key: allergy.id
            }, {
              cover: _withCtx(() => [
                (allergy.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      alt: "example",
                      class: "h-60 object-cover",
                      src: allergy.image,
                      onClick: ($event: any) => (_ctx.router.push(`/profile/${allergy.id}`))
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      alt: "example",
                      class: "h-60 object-cover",
                      src: _imports_0,
                      onClick: ($event: any) => (_ctx.router.push(`/profile/${allergy.id}`))
                    }, null, 8, _hoisted_10))
              ]),
              actions: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: { name: 'UpdateAllergy', params: { id: allergy.id } }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EditOutlined)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_tooltip, {
                    title: "use this button to change risks.",
                    color: "pink"
                  }, {
                    default: _withCtx(() => [
                      (allergy.highRisk)
                        ? (_openBlock(), _createBlock(_component_RiseOutlined, {
                            key: 0,
                            onClick: ($event: any) => (_ctx.markAsHighRisk(allergy, false))
                          }, null, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_FallOutlined, {
                            key: 1,
                            onClick: ($event: any) => (_ctx.markAsHighRisk(allergy, true))
                          }, null, 8, ["onClick"]))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createVNode(_component_a_popconfirm, {
                  title: "Are you sure you want to delete this allergy?",
                  onConfirm: ($event: any) => (_ctx.deleteAllergy(allergy.id))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DeleteOutlined, { key: "ellipsis" })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_card_meta, {
                  title: allergy.name,
                  description: allergy.severity
                }, {
                  avatar: _withCtx(() => []),
                  _: 2
                }, 1032, ["title", "description"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
            : (_openBlock(), _createBlock(_component_a_empty, {
                key: 1,
                class: ""
              }))
        ])),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_a_pagination, {
        "show-size-changer": "",
        current: _ctx.page,
        "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
        pageSize: _ctx.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
        total: _ctx.total
      }, null, 8, ["current", "pageSize", "total"])
    ])
  ], 64))
}